import { EffectReducer } from 'use-effect-reducer'
import { getEffectForRetry } from './effects'
import {
  CardNotPresentPaymentEffect,
  CardNotPresentPaymentEvent,
  CardNotPresentPaymentState,
} from './types'

export const cardNotPresentPaymentStateReducer: EffectReducer<
  CardNotPresentPaymentState,
  CardNotPresentPaymentEvent,
  CardNotPresentPaymentEffect
> = (state, event, exec) => {
  switch (event.type) {
    case 'CNP_CONFIG_OK':
      if (state.status !== 'fetchingCNPConfig') return state
      // reuse intent if already created via Terminal flow
      if (state.clientSecret) {
        return {
          status: 'collectingCardDetails',
          clientKey: event.clientKey,
          clientSecret: state.clientSecret,
        }
      }
      exec({
        type: 'createIntentEffect',
      })

      return {
        status: 'creatingIntent',
        clientKey: event.clientKey,
      }
    case 'INTENT_OK':
      if (state.status !== 'creatingIntent') return state

      return {
        status: 'collectingCardDetails',
        clientKey: state.clientKey,
        clientSecret: event.clientSecret,
      }
    case 'COLLECT_CARD_DETAILS_OK':
      if (state.status !== 'collectingCardDetails') return state

      exec({ type: 'captureEffect', intentId: event.intentId })

      return {
        status: 'capturing',
        intentId: event.intentId,
        clientKey: state.clientKey,
        clientSecret: state.clientSecret,
      }
    case 'CAPTURE_OK':
      if (state.status !== 'capturing') return state

      return {
        status: 'done',
        transaction: event.transaction,
      }
    case 'ERROR':
      return {
        status: 'error',
        errorMessage: event.errorMessage,
        previousState: state,
      }
    case 'RETRY': {
      const { previousState } = event

      const effect = getEffectForRetry(previousState)

      if (!effect) return state

      exec(effect)

      if (previousState.status === 'capturing') {
        return {
          ...previousState,
          isRetry: true,
        }
      }

      return previousState
    }
    default: {
      // This `never` typing will let us know at compile time if we do not handle an existing event type. Neat !
      const _exhaustiveCheck: never = event
      return _exhaustiveCheck
    }
  }
}
